import { getObject } from "../ChoiceApi"

export async function searchPatientTestResults(patientId: number, collectionDateAgeInDays: number):Promise<ISearchPatientTestResultsItem[] | undefined>
{
    return await getObject<ISearchPatientTestResultsItem[]>(`api/EMR/OrderEntry/Patient/Search/${patientId}/${collectionDateAgeInDays}`);
}

export interface ISearchPatientTestResultsItem
{
    labRequisitionId: number,
    collectionDate?: string,
    clientLabName?: string,
    orderItems: string[]
}